import { formatMoney } from 'accounting';
import * as React from 'react';
import { connect } from 'react-redux';
import { IStore } from '../../../common/type';
import { BusyContainer } from '../../../components/BusyContainer';
import { is } from '../../../util/is';
import {
  selectAds,
  selectCustomerName,
  selectIsBusy,
  selectIsError,
  selectTotal
} from '../parts/ads-checkout-selector';
import { IAdsInfo } from '../parts/ads-checkout-type';
import './AdsCheckoutPage.scss';
import { AdsCheckoutRecord } from './AdsCheckoutRecord';

class AdsCheckoutPageContainer extends React.Component<IProps> {
  render() {
    const props = this.props;
    return (
      <main className="page">
        <h1>Ads Checkout Page</h1>
        <BusyContainer isBusy={props.isBusy} isError={props.isError}>
          <div className="ads-checkout--details-container">
            {is.FilledText(props.customerName) ? (
              <h2>Customer Name: {props.customerName}</h2>
            ) : (
              <h2>Guest Customer</h2>
            )}
            <table className="ads-checkout--details-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Title</th>
                  <th>Type</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {props.ads.map((ad, index) => (
                  <AdsCheckoutRecord index={index} key={ad.id} />
                ))}
                <tr className="ads-checkout--total">
                  <td colSpan={3}>Total</td>
                  <td>{props.total}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </BusyContainer>
      </main>
    );
  }
}

interface IStoreProps {
  ads: IAdsInfo[];
  isBusy: boolean;
  isError: boolean;
  total: string;
  customerName: string;
}

type IProps = IStoreProps;

const mapStates = (state: IStore): IStoreProps => ({
  ads: selectAds(state),
  isBusy: selectIsBusy(state),
  isError: selectIsError(state),
  customerName: selectCustomerName(state),
  total: formatMoney(selectTotal(state))
});

export const AdsCheckoutPage = connect(mapStates)(AdsCheckoutPageContainer);



// WEBPACK FOOTER //
// ./src/modules/ads-checkout/components/AdsCheckoutPage.tsx